<template>
  <div>
    <b-btn
      variant="outline-secondary"
      class="social-share"
      @click="modalShow = !modalShow"
    >
      <font-awesome-icon
        :icon="getIcon('share')"
        class="icon"
      />
      Share {{ contentType }}
    </b-btn>
    <AModal
      v-model="modalShow"
      :title="`Share ${contentType} on Social Media`"
    >
      <div class="social-modal">
        <div class="social-group branded">
          <ul class="social-list">
            <li
              v-for="(data, id) in links"
              :key="id"
              class="social-list-item"
            >
              <a
                :href="data.url"
                :title="data.title"
                :class="`social-link ${id}`"
                target="_blank"
              >
                <span class="social-icon">
                  <font-awesome-icon
                    :icon="getIcon(data.icon)"
                    class="icon"
                  />
                </span>
                <span class="text"> {{ data.shareContext }} {{ data.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="pageurl-clipboard">
          <b-input-group>
            <b-form-input
              v-model="pageUrl"
            />
            <b-input-group-append>
              <b-btn
                v-clipboard="pageUrl"
                variant="outline"
                type="button"
                title="Copy to Clipboard"
                @success="showSuccess = true"
              >
                <font-awesome-icon
                  :icon="getIcon('copy')"
                  class="icon"
                />
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <div
            v-if="showSuccess"
            class="alert alert-success"
          >
            <font-awesome-icon
              :icon="getIcon('check')"
              class="icon"
            />
            Copied!
          </div>
        </div>
      </div>
    </AModal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueClipboards from 'vue-clipboards'
import pageMixin from '../node-element-social-sharing-common'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCopy,
  faShare,
  faEnvelope,
  faCheck
} from '@fortawesome/free-solid-svg-icons'

import {
  faXTwitter,
  faTiktok,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faGooglePlusG
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faCheck,
  faCopy,
  faEnvelope,
  faXTwitter,
  faTiktok,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faShare,
  faGooglePlusG
)

Vue.use(VueClipboards)

export default {
  mixins: [
    pageMixin
  ],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    pageurl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: 'Check out this link!'
    }
  },
  data: function() {
    return {
      modalShow: false,
      showSuccess: false
    }
  },
  methods: {
    getIcon: function(type) {
      switch (type) {
      // social media icons
      case 'twitter':
        return ['fab', 'x-twitter']
      case 'tiktok':
        return ['fab', 'tiktok']
      case 'facebook':
        return ['fab', 'facebook-f']
      case 'instagram':
        return ['fab', 'instagram']
      case 'linkedin':
        return ['fab', 'linkedin-in']
      case 'youtube':
        return ['fab', 'youtube']
      case 'googleplus':
        return ['fab', 'google-plus-g']
      case 'email':
        return 'envelope'
      case 'copy':
        return 'copy'
      case 'check':
        return 'check'
      default:
        return 'share'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

$social-icon-size: 1.75em;
$social-icon-color: $white;
$social-icon-border-color: rgba(255, 255, 255, 0.25);
$footer-link: $white;

.social-group {
  margin: 1em 0em;
}
.social-list {
  list-style:none;
  padding:0em;
  margin:0em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.social-list-item{
  width:50%;
  margin-bottom:1em;
  @include media-breakpoint-up(sm) {
  width:33.33%;
  margin-bottom:1.5em;
  }
    a {
    color:$body-color;
  }
}
.social-link  {
  text-decoration: none;
}
  .social-icon {
    box-sizing: content-box;
    height: 1em;
    width: 1em;
    padding: 0.75em;
    margin: 0em auto;
    text-align: center;
    line-height: inherit;
    position: relative;
    display: flex;
    border-radius: 100%;
    margin-bottom:.5em;
  }
  .icon {
    width: 1em;
    height: 1em;
  }
  .social-list-item {
    text-align:center;;
  }

.social-share {
  padding: .75em 1em;
  .icon {
    margin-right:.5em;
  }
}
//define theming, icon sizing for the social items
.social-icon {
  border-radius: 100%;
  @include transition (background-color .3s, border-color .3s, transform .3s);
  font-size: $social-icon-size;
}

@mixin social-icon($color) {
    @include hover-focus {
      .social-icon {
        background-color: darken($color, 15%);
        transform: scale(1.1);
      }
      .icon {
        color:$white;
      }
    }
  .social-icon {
    border-color: $color;
    background-color: $color;
  }
  .icon {
    color: $white;
  }
}

.social-group {
 &.branded {
.social-list {
  .facebook {
  @include social-icon($facebook-brand-color);
  }
  .twitter {
  @include social-icon($twitter-brand-color);
  }
  .tiktok {
    @include social-icon($tiktok-brand-color);
  }
  .linkedin {
  @include social-icon($linkedin-brand-color);
  }
  .youtube {
  @include social-icon($youtube-brand-color);
  }
  .instagram {
  @include social-icon($instagram-brand-color);
  }
  .gooogleplus {
   @include social-icon($google-plus-brand-color);
  }
  .email {
   @include social-icon(#d9dfe3);
  }
}
}
}
.share-input {
  width:100%;
}
.social-modal {
    padding:1em;
  }

//why deep here though?
::v-deep  .modal-title {
  text-transform: capitalize;
  text-align: left;
}

.btn.social-share {
  text-transform: capitalize;
  border-color: var(--main-border-color);
}

.pageurl-clipboard {
.btn{
  border: var(--main-border-color);
  background-color: var(--main-border-color);
  .icon {
    @include transition (opacity .3s);
    opacity:.5;
  }
  @include hover-focus {
  .icon {
    opacity:.75;
  }
  }
}
}
//define boundry around success message
.alert {
  margin:1em 0em;
  text-align: left;
}
</style>
